class VimeoPlayerControls extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.userHasInteracted = false
    this.initializePlayer()
  }

  disconnectedCallback () {
    if (this.observer) this.observer.disconnect()
    super.disconnectedCallback?.()
  }

  async waitForVimeo (attempts = 3, interval = 500) {
    while (attempts-- > 0) {
      if (window.Vimeo) return window.Vimeo
      await new Promise((resolve) => setTimeout(resolve, interval))
    }
    throw new Error('Vimeo SDK not available')
  }

  async initializePlayer () {
    const Vimeo = await this.waitForVimeo()

    const iframe = this.els.iframe?.element || this.querySelector('[data-el="iframe"]') || this.querySelector('iframe')
    if (!iframe) return

    this.player = new Vimeo.Player(iframe)

    this.playButton = this.els.playButton?.element || this.querySelector('[data-el="playButton"]')
    this.soundButton = this.els.soundButton?.element || this.querySelector('[data-el="soundButton"]')

    this.playIcon = this.playButton?.querySelector('img')
    this.soundIcon = this.soundButton?.querySelector('img')

    this.player.ready().then(() => {
      this.setupIntersectionObserver()
      this.setupListeners()
    })
  }

  playVideo () {
    this.player.play()
    if (this.playIcon) {
      this.playIcon.src = this.playButton.dataset.iconPause
      this.playIcon.alt = 'Pause'
    }
  }

  pauseVideo () {
    this.player.pause()
    if (this.playIcon) {
      this.playIcon.src = this.playButton.dataset.iconPlay
      this.playIcon.alt = 'Play'
    }
  }

  muteVideo () {
    this.player.setMuted(true)
    if (this.soundIcon) {
      this.soundIcon.src = this.soundButton.dataset.iconSoundOff
      this.soundIcon.alt = 'Unmute'
    }
  }

  unmuteVideo () {
    this.player.setMuted(false)
    this.player.setVolume(1)
    if (this.soundIcon) {
      this.soundIcon.src = this.soundButton.dataset.iconSoundOn
      this.soundIcon.alt = 'Mute'
    }
  }

  setupIntersectionObserver () {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (this.userHasInteracted) return
        if (entry.isIntersecting) {
          this.playVideo()
        } else {
          this.pauseVideo()
        }
      })
    }, { threshold: 0.2 })

    this.observer.observe(this)
  }

  setupListeners () {
    super.setupListeners()

    if (this.playButton && this.playIcon) {
      this.listeners.add(this.playButton, 'click', () => {
        this.userHasInteracted = true
        this.player.getPaused().then((paused) => {
          if (paused) {
            this.playVideo()
          } else {
            this.pauseVideo()
          }
        })
      })
    }

    if (this.soundButton && this.soundIcon) {
      this.listeners.add(this.soundButton, 'click', () => {
        this.player.getMuted().then((muted) => {
          if (muted) {
            this.unmuteVideo()
          } else {
            this.muteVideo()
          }
        })
      })
    }
  }
}

if (!customElements.get('vimeo-player-controls')) {
  customElements.define('vimeo-player-controls', VimeoPlayerControls)
}
